module.exports = __webpack_public_path__ + "static/media/ghost-user-avatar-dark.42daa74e.png";